module.exports = __webpack_public_path__ + "img/file_format_xls.db4984ad.png";